import { ITestable } from './test-ids';
import { TBreakpointKeys } from '../theme';

export type TMediaSize = 'desktop' | 'mobile';
export type TRootSizeKeys = 'M' | 'L' | 'XL' | 'XXL' | 'XXXL' | 'XXXXL' | 'XXXXXL';

export interface IScalingRoot {
  scalingRoot: TRootSizeKeys;
}

export interface IMetric extends IScalingRoot, ITestable {
  /**
   * The metric value to display
   */
  value: number;

  /**
   * Price unit unit eg. $
   */
  priceUnit?: string;

  /**
   * The optional metric description
   */
  description?: string;

  /**
   * The optional metric interval
   */
  interval?: string;

  /**
   * The previous value if it exists
   */
  previousValue?: number;

  /**
   * The optional measurement unit
   */
  measurementUnit?: string;

  /**
   * The optional aria label
   */
  ariaLabel?: string;

  /**
   * Does the Metric need a margin offset to align with other metrics. Only used when there are groups of elements like plancards
   */
  alignBottom?: boolean;
}

export const ROOT_SIZE_THRESHOLDS: Record<TBreakpointKeys, string> = {
  xs: 'mobile',
  sm: 'mobile',
  md: 'desktop',
  lg: 'desktop',
  xl: 'desktop'
} as const;

export const ROOT_SIZE: Record<TMediaSize, Record<TRootSizeKeys, number>> = {
  mobile: {
    M: 2.4,
    L: 2.8,
    XL: 3.6,
    XXL: 4.4,
    XXXL: 5.2,
    XXXXL: 6.0,
    XXXXXL: 7.2
  },
  desktop: {
    M: 2.8,
    L: 4,
    XL: 4.8,
    XXL: 6,
    XXXL: 7.6,
    XXXXL: 9.6,
    XXXXXL: 12
  }
} as const;
